module.exports = __webpack_public_path__ + "static/media/blueBillPayment19.99c095f0.svg";